import { create } from 'zustand';

/**
 * SKANER OYNASINING holati — butun ilovada BITTA.
 *
 * Nega do'kon: oynani ikki joydan ochish kerak — ombor bo'limidagi tugmadan
 * va skanerning O'ZIDAN (odam hech qayerni bosmaydi, shunchaki etiketkani
 * o'qiydi). Ikkala yo'l ham bir xil oynaga olib borishi shart, aks holda
 * ekranda ikkita bir xil oyna paydo bo'lardi.
 *
 * Oynaning o'zi qobiqda bir marta chiziladi (`GlobalScanner`), bu yerda esa
 * faqat "ochiqmi va qaysi kod bilan" degan javob turadi.
 */
export interface ScannerDialogState {
  open: boolean;
  /**
   * Oyna ochilishiga sabab bo'lgan kod. Tugma bilan ochilsa `null` — odam
   * hali skanerlamagan. Skanerdan ochilsa kod shu yerda va oyna uni darhol
   * ko'rsatib, izlashni boshlaydi.
   */
  code: string | null;
  openScanner: (code?: string) => void;
  closeScanner: () => void;
}

export const useScannerDialog = create<ScannerDialogState>((set) => ({
  open: false,
  code: null,
  openScanner: (code) => set({ open: true, code: code ?? null }),
  closeScanner: () => set({ open: false, code: null }),
}));

/** React dan tashqarida ochish — skaner tinglovchisi shu bilan chaqiradi. */
export const openScanner = (code?: string): void => {
  useScannerDialog.getState().openScanner(code);
};
